import { Card, Col, FormGroup, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { ICreateChallengeInput } from '../../store/api/chellenge/model'
import {
  useCreateChallengeMutation,
  useGetChallengeByIdQuery,
  useUpdateChallengeMutation
} from '../../store/api/chellenge/chellenge'
import { responseError } from '../../validation/validationRequaired'
import { toast } from 'react-toastify'
import Loading from '../Loading/Loading'
import MultiSelectResources from '../../ui/Selects/MultiSelectResources/MultiSelectResources'
import { ISelectData } from '../../ui/Selects/select/model'
import { extractValues } from '../../utils/extractValues'
import { createSingleSelectData } from '../../utils/createSingleSelectData'
import SingleSelect from '../../ui/Selects/select/SingleSelect'
import { USERS_ROLES_FOR_SELECT } from '../../utils/constants'

const CreateChallenges = (): JSX.Element => {
  const { id } = useParams()
  const { t: tGeneral } = useTranslation('general')
  const navigate = useNavigate()
  const [createChallenge] = useCreateChallengeMutation()
  const [updateChallenge] = useUpdateChallengeMutation()
  const [selectedResources, setSelectedResources] = useState<ISelectData[]>([])
  const [selectedRole, setSelectedRole] = useState<ISelectData>()
  const [sendToBeck, setSendToBeck] = useState<ICreateChallengeInput>({} as ICreateChallengeInput)
  const {
    isLoading,
    data: challengeById,
    refetch
  } = useGetChallengeByIdQuery(Number(id), { skip: !id })

  const onChange = (name: string, value: string | File): void => {
    if (name === 'image' && value instanceof File) {
      setSendToBeck(prev => ({ ...prev, image: value }))
    } else if (typeof value === 'string' && value.trim() !== '') {
      setSendToBeck(prev => ({ ...prev, [name]: value.trim() }))
    }
  }
  const fetchCreateChallenge = async (): Promise<void> => {
    const resourceIds = extractValues(selectedResources || [])
    const forRole = selectedRole?.label?.toLowerCase()

    const res = id
      ? await updateChallenge({ id, resourceIds, forRole, ...sendToBeck })
      : await createChallenge({ resourceIds, forRole, ...sendToBeck })

    if ('error' in res) {
      responseError(res)
    } else {
      toast.success('Challenge created successfully!')
      navigate(-1)
    }
  }

  useEffect(() => {
    if (challengeById && id) {
      setSendToBeck({
        name: challengeById.name,
        nameAr: challengeById.nameAr || '',
        description: challengeById.description || '',
        image: challengeById.image || ''
      })
      if (challengeById?.resources) {
        setSelectedResources(
          challengeById.resources.map(resource =>
            createSingleSelectData(resource.name, resource.id)
          )
        )
      }
      if (challengeById?.forRole) {
        const findRole = USERS_ROLES_FOR_SELECT.find(
          ({ label }) => label.toLowerCase() === challengeById.forRole
        )
        if (findRole) {
          setSelectedRole({ label: findRole.label, value: findRole.value })
        }
      }
    }
  }, [challengeById])

  useEffect(() => {
    if (id) {
      refetch()
    }
  }, [id])

  return (
    <div>
      {id && isLoading ? <Loading /> : null}
      <Card.Header>
        <div>
          <h2>{tGeneral(id ? 'editChallenge' : 'createChallenge')}</h2>
        </div>
      </Card.Header>
      <Row>
        <Col lg={12} xl={12} md={12} sm={12}>
          <Card>
            <Card.Body>
              <Row>
                <Col xs={6} md={12}>
                  <FormGroup>
                    <label className='text-dark  mt-5' htmlFor='exampleInputname'>
                      {tGeneral('Name')}
                    </label>
                    <input
                      defaultValue={sendToBeck?.name}
                      name='name'
                      className='form-control'
                      placeholder={tGeneral('name')}
                      onChange={({ target }) => onChange(target.name, target.value)}
                    />
                  </FormGroup>
                </Col>
                <Col xs={6} md={12}>
                  <FormGroup>
                    <label className='text-dark  mt-5' htmlFor='exampleInputname'>
                      {tGeneral('NameAr')}
                    </label>
                    <input
                      defaultValue={sendToBeck?.nameAr}
                      name='nameAr'
                      className='form-control'
                      placeholder={tGeneral('nameAr')}
                      dir='rtl'
                      onChange={({ target }) => onChange(target.name, target.value)}
                    />
                  </FormGroup>
                </Col>
                <Col xs={6} md={12}>
                  <FormGroup>
                    <label className='text-dark  mt-5' htmlFor='exampleInputname'>
                      {tGeneral('description')}
                    </label>
                    <textarea
                      defaultValue={sendToBeck?.description}
                      name='description'
                      className='form-control'
                      onChange={({ target }) => onChange(target.name, target.value)}
                      placeholder={tGeneral('description')}
                    />
                  </FormGroup>
                </Col>
                <Col xs={6} md={12}>
                  <FormGroup>
                    <label className='text-dark mt-5' htmlFor='exampleInputname'>
                      {tGeneral('file')}
                    </label>
                    <input
                      type='file'
                      className='form-control'
                      name='image'
                      accept='image/*'
                      defaultValue={sendToBeck?.image as string}
                      onChange={({ target }) => onChange(target.name, target.files[0])}
                      alt=''
                    />
                  </FormGroup>
                  <div>
                    {sendToBeck?.image && (
                      <div className='avatar avatar-lg  brround cover-image bg-primary mr-10'>
                        <img
                          style={{ width: '200px' }}
                          src={sendToBeck?.image as string}
                          className='avatar avatar-lg  brround cover-image bg-primary'
                          alt=''
                        />
                      </div>
                    )}
                  </div>
                </Col>
                <Col xs={6} md={6}>
                  <label className='text-dark  mt-5' htmlFor='exampleInputname'>
                    {tGeneral('forWho')}
                  </label>
                  <SingleSelect
                    data={USERS_ROLES_FOR_SELECT}
                    editData={selectedRole}
                    setData={setSelectedRole}
                  />
                </Col>
                <Col xs={6} md={6} className='p-0'>
                  <MultiSelectResources
                    selectedResources={selectedResources}
                    setSelectedResources={setSelectedResources}
                  />
                </Col>
              </Row>
            </Card.Body>
            <Card.Footer className='text-end'>
              <button className='btn btn-success mt-1 me-2' onClick={() => fetchCreateChallenge()}>
                {tGeneral('save')}
              </button>
              <button
                type='button'
                className='btn btn-danger mt-1 me-2'
                onClick={() => navigate(-1)}
              >
                {tGeneral('cancel')}
              </button>
            </Card.Footer>
          </Card>
        </Col>
      </Row>
    </div>
  )
}

export default CreateChallenges
